module.exports = __webpack_public_path__ + "img/9788954613606.d6956165.jpg";